import {
  IdentityParameter,
} from "@/features/types";
import useFetcher from "@/utils/use-fetcher";
import { Identity } from "@/features/ui/hooks/use-identity";
import {
  isIdentity,
  toIdentityParameter,
} from "@/features/ui/helpers/identity-helpers";
import { getUrlPrefixByIdentityParameter } from "@/features/ui/helpers/zwr-helpers";
import useSWR, { SWRConfiguration } from "swr";


export interface GetLineSheetSetFilterInfoRequest {
  lineSheetSetId: number;
  lineSheetId?: number;
  lineSheetTabIndex?: number;
}

export interface GetLineSheetSetFilterInfoResponse {
  brands: string[];
  genders: string[];
  categories: string[];
  seasons: string[];
}

export interface GetLineSheetSetFilterInfoPathParameter extends IdentityParameter {}

export function getGetLineSheetSetFilterInfoPathParameter(
  identity: Identity | null
): GetLineSheetSetFilterInfoPathParameter | null {
  return toIdentityParameter(identity);
}

export function getGetLineSheetSetFilterInfoKey(
  identityOrParameter?: Identity | GetLineSheetSetFilterInfoPathParameter | null,
  request?: GetLineSheetSetFilterInfoRequest
) {
  if (identityOrParameter) {
    let parameter;
    if (isIdentity(identityOrParameter)) {
      parameter = getGetLineSheetSetFilterInfoPathParameter(identityOrParameter)!!;
    } else {
      parameter = identityOrParameter;
    }
    const prefix = getUrlPrefixByIdentityParameter(parameter);
    return {
      url: `${prefix}/line-sheet-sets/filter-info`,
      params: request,
    };
  }
  return null;
}

export default function useGetLineSheetSetFilterInfo(
  parameter?: GetLineSheetSetFilterInfoPathParameter | null,
  request?: GetLineSheetSetFilterInfoRequest,
  config?: SWRConfiguration
) {
  const fetcher = useFetcher<GetLineSheetSetFilterInfoRequest, GetLineSheetSetFilterInfoResponse>();
  return useSWR(getGetLineSheetSetFilterInfoKey(parameter, request), fetcher, config);
}
